const project = JSON.parse(String(process.env.PROJECT));
const config = {
    APP_URL: process.env.APP_URL,
    API_URL: process.env.API_URL,
    FOLDER: project.folder,
    IS_SERVER: process.env.IS_SERVER,
    APP_NAME: process.env.APP_NAME || project.appName,
    BASE_URL: process.env.BASE_URL,
    VERSION: process.env.VERSION,
    LOCALE_PREFIX: project.localePrefix || '',
    GTM: project.GTM,
    USE_CDN: project.useCDN,
    CDN_FOLDER: project.cdnFolder || '',
    IS_PROD: process.env.NODE_ENV === 'production',
    TYPE: project.type || 'com',
    LIVE_WSS_DISABLED: !!project.LIVE_WSS_DISABLED,
    WSS_PROXY_URL: project.WSS_PROXY_URL,
    IS_DEV: process.env.NODE_ENV === 'development',
    IS_TEST: process.env.BUILD_ENV === 'test',
    IS_MOBILE: project.isMobile || false,
};
export const setConfig = (key, val) => {
    config[key] = val;
};
export const getConfig = key => config[key] || '';



// WEBPACK FOOTER //
// ./src/web-frontend-core/config.js